export default __webpack_public_path__ + "static/media/adresse_card_icon.29d11156.svg";